import React from 'react';

import { RenderOrder } from '@paragon/three-shared';

import { useAntiZoomFactor } from '../antiZoom';
import { getSnapGeometry, getSnapMaterial } from '../util/SnapGeometryCache';

export type SnapType = 'Midline' | 'Centroid' | 'Intersection' | 'Vertex';

interface Props {
  readonly snapType: SnapType;
  readonly size?: number;
  readonly position: readonly [number, number, number];
  readonly isSelected?: boolean;
}

export function SnapVisual({ snapType, size = 1, position, isSelected = false }: Props) {
  const antiZoomFactor = useAntiZoomFactor();

  const scale = size * antiZoomFactor.value;

  return (
    <mesh
      renderOrder={RenderOrder.SnapVisual}
      position={position}
      scale={[scale, scale, scale]}
      geometry={getSnapGeometry(snapType)}
      material={getSnapMaterial(snapType, isSelected)}
    />
  );
}
